module.exports = __webpack_public_path__ + "img/3b07a047121e401a510da5ff2865838e.png";